import {css} from "@emotion/react";

export interface IGlobalTheme {
    fonts: {
        font_family: string;
        font_size_root: string;
        font_size_base: string;
        line_height_base: number;
        font_weight_base: number;
    };
    colors: {
        body_bg: string;
        text_color: string;
        link_color: string;
        link_color_hover: string;
    };
}

export const scaffolding = (theme: IGlobalTheme) => {
    return css`
        * {
            box-sizing: border-box;
        }

        html {
            font-size: ${theme.fonts.font_size_root} !important;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }

        body {
            font-size: ${theme.fonts.font_size_base};
            font-weight: ${theme.fonts.font_weight_base};
            line-height: ${theme.fonts.line_height_base};
            color: ${theme.colors.text_color};
            background-color: ${theme.colors.body_bg};
        }

        html,
        body {
            font-family: ${theme.fonts.font_family};
        }

        a {
            color: ${theme.colors.link_color};
            text-decoration: none;

            &:hover,
            &:focus {
                color: ${theme.colors.link_color_hover};
                text-decoration: underline;
            }
        }

        input,
        button,
        select,
        textarea {
            font-family: inherit;
            font-size: inherit;
            line-height: inherit;
        }

        [role="button"] {
            cursor: pointer;
        }
    `;
};
